/* eslint consistent-return: "off", no-console: "off" */
(() => {
  const initYTVideos = () => {
    // Initilize when DOM is loaded
    const youTubeMedia = document.querySelectorAll('[data-video-url]');

    if (!youTubeMedia) return;

    function error() {
      console.error('Error: Invalid YouTube URL or no "data-video-url" attribute found in the media DOM element(s):', youTubeMedia);
    }

    function getYouTubeId(url) {
      const IdIndex = url.includes('youtube') ? url.indexOf('v=') : url.indexOf('e/');
      const id = url.slice(IdIndex + 2);
      return id;
    }

    function getYouTubeIndex(url) {
      for (let index = 0; index < youTubeMedia.length; index += 1) {
        const elUrl = youTubeMedia[index].dataset.videoUrl;
        if (elUrl === url) {
          return index;
        }
      }
    }

    // function onPlayerStateChange(event) {
    //   // console.log('playing');
    //   const playerId = event.target.playerInfo.videoData.video_id;
    //   const target = document.querySelector(`iframe[src*=${playerId}]`);
    //   const parent = target.parentElement;

    //   console.log(event);

    //   if (event.data === window.YT.PlayerState.PLAYING) {
    //     // console.log('yt video playing', target);
    //     parent.classList.add('--play');
    //   }

    //   if (event.data === window.YT.PlayerState.ENDED) {
    //     // console.log('yt video ended');
    //   }
    // }

    // YouTube IFrame API
    function createYouTubePlayer(playerId, youTubeId) {
      return new window.YT.Player(playerId, {
        videoId: youTubeId,
        playerVars: {
          playsinline: 1,
          modestbranding: 1,
          rel: 0,
        },
        events: {
          // onStateChange: onPlayerStateChange,
          // 'onStateChange': () => { console.log(YT.PlayerState.PLAYING); },
        },
      });
    }

    function addYouTubeVideo(videoUrl) {
      const youTubeId = getYouTubeId(videoUrl);
      const youTubeIndex = getYouTubeIndex(videoUrl);
      youTubeMedia[youTubeIndex].insertAdjacentHTML('afterbegin', `<div id="yt-video__player-${youTubeIndex}" class="yt-video__player"></div>`);
      createYouTubePlayer(`yt-video__player-${youTubeIndex}`, youTubeId);
      document.getElementById(`yt-video__player-${youTubeIndex}`);
    }

    // Build video data
    const youTubeVideos = [];
    youTubeMedia.forEach((el) => {
      const videoArray = [];
      const videoUrl = el.dataset.videoUrl;
      if (!videoUrl) {
        error();
      }

      videoArray.push(videoUrl);
      youTubeVideos.push(videoArray);
    });

    /* Wait for YT to be ready */
    if (youTubeVideos.length > 0) {
      window.YT.ready(() => {
        // console.log('YT ready');
        youTubeVideos.forEach((video) => {
          const videoUrl = video[0];
          addYouTubeVideo(videoUrl);
        });
      });
    } else {
      error();
    }
  };

  if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
    initYTVideos();
  } else {
    document.addEventListener('DOMContentLoaded', initYTVideos);
  }
})();
